"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPermission = getPermission;
exports.getToken = getToken;
exports.removeToken = removeToken;
exports.setPermission = setPermission;
exports.setToken = setToken;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var TokenKey = 'token';
function getToken() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TokenKey;
  return _jsCookie.default.get(key);
}
function setToken(token) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TokenKey;
  return _jsCookie.default.set(key, token);
}
function removeToken() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TokenKey;
  return _jsCookie.default.remove(key);
}
function getPermission() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TokenKey;
  return _jsCookie.default.get(key);
}
function setPermission(token) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TokenKey;
  return _jsCookie.default.set(key, token);
}